// Mantine
import { Button, Modal, Select, NumberInput } from '@mantine/core'

// React
import { useState } from 'react'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// UI
import Box from '../ui/Box'
import Shipment from '../ui/Shipment'

export default function FulfillmentOrdersShipments({
    fulfillment_order,
    loadFullfillmentOrder,
}) {
    const shipments = fulfillment_order.shipments

    // Generate shipment
    const [generateModalOpened, setGenerateModalOpened] = useState(false)
    const [isGeneratingShipment, setIsGeneratingShipment] = useState(false)

    const [packagesNumber, setPackagesNumber] = useState(1)

    const openGenerateModal = () => {
        setPackagesNumber(1)
        setGenerateModalOpened(true)
    }

    const closeGenerateModal = () => setGenerateModalOpened(false)

    const { requestPost } = useAxiosApi()

    const generate = async () => {
        setIsGeneratingShipment(true)

        const endpoint =
            '/fulfillment-orders/' +
            fulfillment_order.id +
            '/generate-shipment'

        try {
            await requestPost(endpoint, {
                number_of_packages: packagesNumber,
            })

            await loadFullfillmentOrder()

            closeGenerateModal()
        } catch (error) {
            console.log(error)
        }

        setIsGeneratingShipment(false)
    }

    // Cancel shipment
    const cancelShipment = async (shipment) => {
        await requestPost(`/shipments/${shipment.id}/cancel`)

        await loadFullfillmentOrder()
    }

    return (
        <Box title="Bordereau d'expédition">
            {shipments.length === 0 && (
                <span className="text-gray-500">Aucun bordereau</span>
            )}

            <div className="flex flex-col gap-3">
                {shipments.map((shipment) => (
                    <Shipment key={shipment.id} shipment={shipment} />
                ))}
            </div>

            <div className="flex justify-center mt-5 items-center gap-3">
                <Button variant="default" onClick={openGenerateModal}>
                    {shipments.length === 0
                        ? 'Générer un bordereau'
                        : 'Regénérer le bordereau'}
                </Button>
            </div>

            <Modal
                opened={generateModalOpened}
                onClose={closeGenerateModal}
                size="lg"
                title="Générer un bordereau pour tous les produits"
            >
                <div className="flex flex-col gap-5">
                    <div className="flex flex-col hidden">
                        <span className="font-medium">Incoterm</span>

                        <Select
                            allowDeselect={false}
                            data={[
                                {
                                    label: 'DAP',
                                    value: 'DAP',
                                },
                                {
                                    label: 'DDP',
                                    value: 'DDP',
                                },
                            ]}
                        />
                    </div>

                    <div className="flex flex-col">
                        <span className="font-medium">Nombre de colis</span>

                        <NumberInput
                            value={packagesNumber}
                            onChange={setPackagesNumber}
                            clampBehavior="strict"
                            min={1}
                            max={200}
                        />
                    </div>

                    <div className="flex flex-col">
                        <span className="font-medium">Lieu de préparation</span>
                        <span>{fulfillment_order.location.name}</span>
                    </div>

                    <Button loading={isGeneratingShipment} onClick={generate}>
                        Générer le bordereau
                    </Button>
                </div>
            </Modal>
        </Box>
    )
}
